
















import Vue from "vue";
import Component from "vue-class-component";
import BlogItem from "@/components/blog/item.vue";
import { AppSearchService } from "@/common/api";
import { Prop, Watch } from "vue-property-decorator";
import _debounce from "lodash/debounce";

@Component({
  name: "BlogIndex",
  components: {
    BlogItem,
  },
})
export default class BlogIndex extends Vue {
  @Prop({
    default: () => "",
  })
  keyword;

  public infiniteId = 0;

  public articles = [];

  public params = {
    page: 1,
    perPage: 20,
    searchKey: "hashtag",
  };

  public infiniteHandler: any;

  @Watch("keyword")
  changeSelected() {
    this.params.page = 1;
    this.articles = [];
    this.infiniteId += 1;
  }

  created() {
    this.infiniteHandler = _debounce(async ($state) => {
      await this.getList($state);
    }, 500);
  }

  public async getList($state) {
    const keyword = this.keyword;
    const result = await AppSearchService.userSearchArticles({
      ...this.params,
      ...{ keyword: keyword },
    });

    if (result.data.articles.length > 0) {
      this.params.page += 1;
      this.articles.push(...result.data.articles);
      $state.loaded();
    } else {
      try {
        $state.complete();
      } catch (error) {
        console.log(error);
      }
    }
  }
}
